import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const creditUpdate = () => {
  return dispatch => { 
    APIGet(UrlServer.URL_GET_CREDIT_UPDATE_CREDIT_ITWIST, datas => {
      APIPost(UrlServer.URL_POST_CREDIT_GET_CREDIT, {}, datas => {
        dispatch({ type: actionTypes.CREDIT_UPDATE, credit: datas.datas })
      })
    })
  }
}